export const PATH_REGISTRATION = `/registration`;

export enum pathsRegistration {
  Step1 = '/reg1',
  Step2 = '/reg2',
  Step3 = '/reg3',
  Step4 = '/reg4',
  Step5 = '/reg5',
  Step6 = '/documents',
  Step7 = '/finbit',
  Step8 = '/experian',
  Step9 = '/photo-upload',
  Step10 = '/confirmation-conditions',
}

export const PATH_REGISTRATION_STEP_1 = `${PATH_REGISTRATION}${pathsRegistration.Step1}`;
export const PATH_REGISTRATION_STEP_2 = `${PATH_REGISTRATION}${pathsRegistration.Step2}`;
export const PATH_REGISTRATION_STEP_3 = `${PATH_REGISTRATION}${pathsRegistration.Step3}`;
export const PATH_REGISTRATION_STEP_4 = `${PATH_REGISTRATION}${pathsRegistration.Step4}`;
export const PATH_REGISTRATION_STEP_5 = `${PATH_REGISTRATION}${pathsRegistration.Step5}`;
export const PATH_REGISTRATION_STEP_6 = `${PATH_REGISTRATION}${pathsRegistration.Step6}`;
export const PATH_REGISTRATION_STEP_7 = `${PATH_REGISTRATION}${pathsRegistration.Step7}`;
export const PATH_REGISTRATION_STEP_8 = `${PATH_REGISTRATION}${pathsRegistration.Step8}`;
export const PATH_REGISTRATION_STEP_9 = `${PATH_REGISTRATION}${pathsRegistration.Step9}`;
export const PATH_REGISTRATION_STEP_10 = `${PATH_REGISTRATION}${pathsRegistration.Step10}`;

export enum PathsDocuments {
  AADHAAR_VERIFICATION = '/aadhaar_verification',
  AADHAAR_OTP = '/aadhaar_otp',
  NO_SERVICE = '/no_service',
}

export enum PathBankStatements {
  MAIN = '',
  UPLOAD = '/upload-bank-statement',
  SETUP = '/setup-account-aggregator',
}

export enum PathPhoneConfirmation {
  MAIN = '',
  TERMS = '/confirm-terms',
}

export const PATH_CONFIRM_TERMS = `${PATH_REGISTRATION_STEP_2}${PathPhoneConfirmation.TERMS}`;
export const PATH_DOCUMENTS_AADHAAR_VERIFICATION = `${PATH_REGISTRATION_STEP_6}${PathsDocuments.AADHAAR_VERIFICATION}`;
export const PATH_DOCUMENTS_AADHAAR_OTP = `${PATH_REGISTRATION_STEP_6}${PathsDocuments.AADHAAR_OTP}`;
export const PATH_DOCUMENTS_NO_SERVICE = `${PATH_REGISTRATION_STEP_6}${PathsDocuments.NO_SERVICE}`;
export const PATH_BANK_STATEMENT_UPLOAD = `${PATH_REGISTRATION_STEP_7}${PathBankStatements.UPLOAD}`;
export const PATH_BANK_STATEMENT_SETUP = `${PATH_REGISTRATION_STEP_7}${PathBankStatements.SETUP}`;

export const getProgressLineStep = (pathName: string) => {
  switch (pathName) {
    case PATH_REGISTRATION_STEP_1:
    case PATH_REGISTRATION_STEP_2:
    case PATH_CONFIRM_TERMS:
      return 0;
    case PATH_REGISTRATION_STEP_3:
      return 1;
    case PATH_REGISTRATION_STEP_4:
      return 2;
    case PATH_REGISTRATION_STEP_5:
      return 4;
    case PATH_REGISTRATION_STEP_6:
    case PATH_DOCUMENTS_AADHAAR_VERIFICATION:
    case PATH_DOCUMENTS_AADHAAR_OTP:
      return 5;
    case PATH_REGISTRATION_STEP_7:
    case PATH_BANK_STATEMENT_UPLOAD:
      return 6;
    case PATH_REGISTRATION_STEP_8:
      return 7;
    case PATH_REGISTRATION_STEP_9:
      return 8;
    case PATH_REGISTRATION_STEP_10:
      return 9;
    default:
      return 0;
  }
};
